import MainContainer from './games-main-container';

export default {
    path: '/',
    component: MainContainer,
    routes: []
};



// WEBPACK FOOTER //
// ./src/js/routes/app/routes/games/routes/main/index.jsx